import type { ClaimAnalysisResponse, ClaimAnalysisResult } from '../types/claim-analysis';

/**
 * 生成陈述书对照页内容的选项
 */
export interface StatementComparisonOptions {
    /**
     * 陈述书内容
     */
    statementDocument: string;
    /**
     * 对照字段类型：权利要求或说明书
     */
    field: 'claim' | 'description';
}

/**
 * OAR 任务基本信息服务
 */
export interface OarTaskService {
    /**
     * 分析指定结论性意见的权利要求
     * @param taskId - 任务标识符
     * @param conclusiveOpinionId - 结论性意见 ID
     * @param signal - 可选的 AbortSignal，用于取消轮询
     * @returns 权利要求分析响应
     */
    analyzeClaims(taskId: string, conclusiveOpinionId: string, signal?: AbortSignal): Promise<ClaimAnalysisResponse>;
    /**
     * 生成陈述书内容（异步任务模式）
     * @param taskId - 任务标识符
     * @param claimAnalysisResults - 权利要求分析结果列表
     * @param signal - 可选的 AbortSignal，用于取消轮询
     * @returns 生成的陈述书内容字符串
     */
    generateStatementContent(taskId: string, claimAnalysisResults: ClaimAnalysisResult[], signal?: AbortSignal): Promise<string>;
    /**
     * 生成陈述书对照页内容
     * @param taskId - 任务标识符
     * @param options - 生成选项
     * @returns 生成的对照页内容字符串
     */
    generateStatementComparisonContent(taskId: string, options: StatementComparisonOptions): Promise<string>;
}

/**
 * OAR 任务服务依赖注入符号（公共接口）
 */
export const OarTaskService = Symbol('OarTaskService');

/**
 * OAR 任务服务基础实现依赖注入符号（内部使用）
 * 用于解决缓存装饰器的循环依赖问题
 */
export const BaseOarTaskService = Symbol('BaseOarTaskService');
